export default __webpack_public_path__ + "static/media/CTF.311a78cd.png";